/**
 * Registers a new session identifier or reads a current one in/from the session storage and returns its value.
 */
const getOrCreateSessionId = function () {
  const sessionPropertyName = 'sessionId';
  const storedSessionId = sessionStorage.getItem(sessionPropertyName);

  if (storedSessionId) {
    return storedSessionId;
  }

  const newSessionId = crypto.randomUUID();
  sessionStorage.setItem(sessionPropertyName, newSessionId);

  return newSessionId;
};

export default {
  getOrCreateSessionId,
};
